// extracted by mini-css-extract-plugin
module.exports = {"scrollerRoot":"scrollerRoot__3g19--mKXAFX","hidden":"hidden__3rjKXzzPDEG1"};